/* eslint-disable react-refresh/only-export-components */
/**
 * AdminHubContext
 *
 * Wraps useAdminOrchestratorHub so the connection-status pill in Header.tsx
 * reads the same SignalR state as the /live page without prop-drilling.
 */

import {
  createContext,
  useContext,
  type ReactNode,
} from 'react';
import {
  useAdminOrchestratorHub,
  type AdminOrchestratorEvent,
  type ConnectionState,
} from '../hooks/useAdminOrchestratorHub';

interface AdminHubContextType {
  events: AdminOrchestratorEvent[];
  status: ConnectionState;
  pause: () => void;
  resume: () => void;
}

const AdminHubContext = createContext<AdminHubContextType | undefined>(undefined);

export function AdminHubProvider({ children }: { children: ReactNode }) {
  const hub = useAdminOrchestratorHub();

  return (
    <AdminHubContext.Provider value={hub}>
      {children}
    </AdminHubContext.Provider>
  );
}

export function useAdminHub(): AdminHubContextType {
  const ctx = useContext(AdminHubContext);
  if (!ctx) throw new Error('useAdminHub must be used within AdminHubProvider');
  return ctx;
}
